import { render, staticRenderFns } from "./customCascader.vue?vue&type=template&id=4d38c46c"
import script from "./customCascader.vue?vue&type=script&lang=ts"
export * from "./customCascader.vue?vue&type=script&lang=ts"
import style0 from "./customCascader.vue?vue&type=style&index=0&id=4d38c46c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports